export const AOM_HP_ROLES = ['Contact For AOM Service Question', 'Pricing Contact']
export const PBM_HP_ROLES = ['Pricing Contact']
export const UNIQUE_ROLE_INFO = 'cng-contact_hp_roles-unique_role_info'
